<div class="logo-big">
  <img [src]="logo" />
</div>
<div class="forgot-container">
  <h3 class="text-center">Restore Password</h3>
  <div class="form-container">
    <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
      <div class="control margin-bottom">
        <label for="email">Email</label>
        <lib-cm-input
          placeholder=""
          formControlName="email"
          id="email"
          [titlecase]="false"
        ></lib-cm-input>
      </div>

      <div class="margin-bottom">
        Enter the email address you used to create the account. Check your email inbox, and follow
        the instructions in the email to restore password.
      </div>

      <button type="submit" class="submit-btn margin-bottom" [disabled]="submitBtnDisabled">
        <div class="spinner-rect-container" [class.show]="loading">
          <spinner-rect color="white"></spinner-rect>
        </div>
        <div class="title" [class.not-visible]="loading">Send Email</div>
      </button>

      <div class="link margin-bottom text-center">
        <a routerLink="/login">Back</a>
      </div>

      @if (error) {
      <div class="error-container">
        <span class="error">
          <span class="error-message">
            {{ 'ERROR: ' + error }}
          </span>
        </span>
      </div>
      }
    </form>
  </div>
</div>
